// 导入环境配置
import envConfig from './config/env.config';

// API 配置
export const API_BASE_URL = envConfig.API_BASE_URL;

// 其他配置
export const APP_CONFIG = {
  appName: envConfig.APP_NAME,
  version: envConfig.VERSION,
  debug: envConfig.DEBUG
};